"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuContentItemForFloaty = exports.MenuContentItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _atoms = require("../../../atoms");

var _Icons = require("../../../atoms/Icons");

var StyledMenuContentItemList = (0, _styledComponents.default)(_atoms.Grid).withConfig({
  displayName: "MenuContentItem__StyledMenuContentItemList",
  componentId: "h83nyd-0"
})({
  listStyle: 'none'
});
var StyledMenuContentItemListItem = (0, _styledComponents.default)(_atoms.GridItem).withConfig({
  displayName: "MenuContentItem__StyledMenuContentItemListItem",
  componentId: "h83nyd-1"
})({});

var MenuContentItem = function MenuContentItem(props) {
  var options = props.options;
  return _react.default.createElement(_atoms.Flex, {
    as: "nav",
    backgroundColor: "ghosted.copoazu.light",
    paddingY: 6,
    alignItems: "center",
    justifyContent: "center"
  }, _react.default.createElement(StyledMenuContentItemList, {
    as: "ul",
    margin: 0,
    alignItems: "center",
    justifyContent: "center",
    gridTemplateColumns: ['1fr 1fr', '1fr 1fr', 'auto auto auto auto'],
    gridTemplateRows: ['auto', 'auto', '1fr'],
    gridGap: ['12px 12px', '12px 12px', '0']
  }, options === null || options === void 0 ? void 0 : options.map(function (option) {
    return _react.default.createElement(StyledMenuContentItemListItem, {
      as: "li",
      key: "option-".concat(option.id),
      marginLeft: 1,
      marginRight: 1
    }, _react.default.createElement(_atoms.Button, {
      buttonType: "secondary",
      size: "small",
      action: function action(e) {
        e.preventDefault();
        option.action(option.id, e);
      },
      disabled: option.disabled,
      width: ['100%', '100%', 'inherit']
    }, option.icon && _react.default.createElement(_atoms.Icon, {
      color: "coco",
      size: "micro",
      marginRight: 2
    }, option.icon), _react.default.createElement(_atoms.TextForm, {
      size: "tiny",
      fontWeight: "medium",
      color: "coco",
      style: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
      },
      maxWidth: ['70px', '100px', 'auto']
    }, option.label)));
  })));
};

exports.MenuContentItem = MenuContentItem;

var MenuContentItemForFloaty = function MenuContentItemForFloaty(props) {
  var options = props.options;
  return _react.default.createElement(_atoms.Flex, {
    as: "nav",
    alignItems: "center",
    justifyContent: "center"
  }, _react.default.createElement(StyledMenuContentItemList, {
    as: "ul",
    margin: 0,
    alignItems: "center",
    justifyContent: "center",
    gridTemplateColumns: ['auto auto auto auto'],
    gridTemplateRows: ['auto', 'auto', '1fr'],
    gridGap: ['12px 12px', '12px 12px', '0']
  }, options === null || options === void 0 ? void 0 : options.map(function (option, index) {
    return _react.default.createElement(StyledMenuContentItemListItem, {
      as: "li",
      key: "option-".concat(option.id),
      marginLeft: index === 0 ? 0 : 1,
      marginRight: 1
    }, _react.default.createElement(_atoms.Button, {
      buttonType: "secondary",
      size: "small",
      action: function action(e) {
        e.preventDefault();
        option.action(option.id, e);
      },
      disabled: option.disabled,
      width: ['100%', '100%', 'inherit']
    }, option.icon && _react.default.createElement(_atoms.Icon, {
      color: "coco",
      size: ['small', 'small', 'micro'],
      marginRight: [0, 0, 2]
    }, option.icon), _react.default.createElement(_atoms.TextForm, {
      size: "tiny",
      fontWeight: "medium",
      color: "coco",
      display: ['none', 'none', 'inherit']
    }, option.label)));
  })));
};

exports.MenuContentItemForFloaty = MenuContentItemForFloaty;
MenuContentItem.defaultProps = {
  options: [{
    id: 'text',
    label: 'Texto',
    icon: _react.default.createElement(_Icons.SearchHeavy, null),
    action: void 0,
    disabled: false
  }]
};
MenuContentItemForFloaty.defaultProps = {
  options: [{
    id: 'text',
    label: 'Texto',
    icon: _react.default.createElement(_Icons.SearchHeavy, null),
    action: void 0,
    disabled: false
  }]
};